export default __webpack_public_path__ + "static/media/helper.3a54239f.svg";